const Navbar = "navbar-portal";

const Portals = {
    Navbar,
};

export default Portals;
